var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-carousel',{staticStyle:{"padding":"15px 5%"},attrs:{"autoplay":""}},[_c('div',[_c('img',{attrs:{"src":"https://eval.t.educg.com/img/bianyidasai001.32f13557.jpeg","width":"50%"}})]),_c('div',[_c('h3',[_vm._v("2")])]),_c('div',[_c('h3',[_vm._v("3")])]),_c('div',[_c('h3',[_vm._v("4")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }